import AppHeader from "../../components/AppHeader";
import AppContent from "../../components/AppContent";
import AppFooter from "../../components/AppFooter";

export const DefaultLayout = () => {
  return (
    <div>
      <div className="default-layout">
        <AppHeader />
        <div>
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  );
};
